import { PredefinedFileTags } from './photo.dto';

export const isRetouchedPhoto = (photo: { tags?: readonly string[] | null }): boolean =>
  photo.tags?.includes(PredefinedFileTags.RETOUCHED) ?? false;

/** Retouched by the service (AI), not by hand. */
export const isAutoRetouchedPhoto = (photo: { tags?: readonly string[] | null }): boolean =>
  photo.tags?.includes(PredefinedFileTags.AUTO_RETOUCHED) ?? false;
